(function(){
  "use strict";

  // ---------- Camera library (deep-sky: cooled CMOS + CCD + DSLR/mirrorless) ----------
  // Flat-relevant specs come from the sensor die (bit depth + amp glow) and the
  // camera class (type + mechanical shutter). Bit depth = the ADC/file scale software reports.
  var SENSORS = {
    imx571:{bits:16,amp:false}, imx455:{bits:16,amp:false}, imx461:{bits:16,amp:false}, imx411:{bits:16,amp:false},
    imx533:{bits:14,amp:false}, imx294:{bits:14,amp:true}, imx492:{bits:14,amp:true}, imx410:{bits:14,amp:false},
    imx071:{bits:14,amp:true}, imx193:{bits:14,amp:false}, imx128:{bits:14,amp:true}, imx269:{bits:14,amp:true},
    imx183:{bits:12,amp:true}, mn34230:{bits:12,amp:true},
    imx585:{bits:12,amp:false}, imx676:{bits:12,amp:false}, imx428:{bits:12,amp:false}, imx304:{bits:12,amp:false},
    imx432:{bits:12,amp:false}, imx429:{bits:12,amp:false},
    gsense4040:{bits:16,amp:true}, gsense4040bsi:{bits:16,amp:true}, gsense2020bsi:{bits:16,amp:true},
    icx694:{bits:16,amp:false}, icx814:{bits:16,amp:false}, kaf8300:{bits:16,amp:false}, kaf6303:{bits:16,amp:false},
    kai11002:{bits:16,amp:false}, kaf16200:{bits:16,amp:false}, kaf9000:{bits:16,amp:false}, kaf16803:{bits:16,amp:false}
  };
  // [group, label, sensor|null, type, shutter, bitsOverride?]
  var CAMERAS = [
    ["ZWO","ZWO ASI2600 MC/MM Pro (IMX571)","imx571","cmos",false],
    ["ZWO","ZWO ASI6200 MC/MM Pro (IMX455)","imx455","cmos",false],
    ["ZWO","ZWO ASI2400 MC Pro (IMX410)","imx410","cmos",false],
    ["ZWO","ZWO ASI533 MC/MM Pro (IMX533)","imx533","cmos",false],
    ["ZWO","ZWO ASI294 MC/MM Pro (IMX294/492)","imx294","cmos",false],
    ["ZWO","ZWO ASI183 MC/MM Pro (IMX183)","imx183","cmos",false],
    ["ZWO","ZWO ASI1600 MM/MC Pro (MN34230)","mn34230","cmos",false],
    ["ZWO","ZWO ASI071 MC Pro (IMX071)","imx071","cmos",false],
    ["ZWO","ZWO ASI128 MC Pro (IMX128)","imx128","cmos",false],
    ["ZWO","ZWO ASI461 MM/MC (IMX461)","imx461","cmos",false],
    ["ZWO","ZWO ASI411 MM (IMX411)","imx411","cmos",false],

    ["QHYCCD","QHY268 M/C (IMX571)","imx571","cmos",false],
    ["QHYCCD","QHY600 M/C (IMX455)","imx455","cmos",false],
    ["QHYCCD","QHY410C (IMX410)","imx410","cmos",false],
    ["QHYCCD","QHY294 M/C Pro (IMX294/492)","imx294","cmos",false],
    ["QHYCCD","QHY183 M/C (IMX183)","imx183","cmos",false],
    ["QHYCCD","QHY533 M/C (IMX533)","imx533","cmos",false],
    ["QHYCCD","QHY461 M/C (IMX461)","imx461","cmos",false],
    ["QHYCCD","QHY411 M (IMX411)","imx411","cmos",false],
    ["QHYCCD","QHY247C (IMX193)","imx193","cmos",false],
    ["QHYCCD","QHY128C (IMX128)","imx128","cmos",false],
    ["QHYCCD","QHY585M (IMX585)","imx585","cmos",false],
    ["QHYCCD","QHY miniCAM8C (IMX585)","imx585","cmos",false],
    ["QHYCCD","QHY4040 (GSENSE4040)","gsense4040","cmos",false],
    ["QHYCCD","QHY2020 (GSENSE2020BSI)","gsense2020bsi","cmos",false],

    ["Player One","Player One Poseidon-C/M Pro (IMX571)","imx571","cmos",false],
    ["Player One","Player One Ares-C/M Pro (IMX533)","imx533","cmos",false],
    ["Player One","Player One Uranus-M Pro (IMX585)","imx585","cmos",false],
    ["Player One","Player One Apollo-M MAX Pro (IMX432)","imx432","cmos",false],
    ["Player One","Player One Apollo 428M MAX Pro (IMX428)","imx428","cmos",false],

    ["ToupTek","ToupTek ATR585C/M (IMX585)","imx585","cmos",false],
    ["ToupTek","ToupTek AE676C (IMX676)","imx676","cmos",false],

    ["Altair","Altair Hypercam 26C/26M (IMX571)","imx571","cmos",false],
    ["Altair","Altair Hypercam 269C (IMX269)","imx269","cmos",false],
    ["Altair","Altair Hypercam 294C (IMX294)","imx294","cmos",false],
    ["Altair","Altair Hypercam 183C/M (IMX183)","imx183","cmos",false],

    ["Svbony","Svbony SV405CC (IMX294)","imx294","cmos",false],
    ["Svbony","Svbony SV605CC/MC (IMX533)","imx533","cmos",false],

    ["Omegon","Omegon veTEC 571 C/M (IMX571)","imx571","cmos",false],
    ["Omegon","Omegon veTEC 410 C (IMX410)","imx410","cmos",false],
    ["Omegon","Omegon veTEC 533 C (IMX533)","imx533","cmos",false],
    ["Omegon","Omegon veTEC 432 M (IMX432)","imx432","cmos",false],

    ["Atik","Atik Apx60 (IMX455)","imx455","cmos",false],
    ["Atik","Atik Apx26 (IMX571)","imx571","cmos",false],
    ["Atik","Atik Horizon II (MN34230)","mn34230","cmos",false],
    ["Atik","Atik ACIS 7.1 (IMX428)","imx428","cmos",false],
    ["Atik","Atik ACIS 12.3 (IMX304)","imx304","cmos",false],
    ["Atik","Atik 460EX (ICX694 CCD)","icx694","ccd",false],
    ["Atik","Atik 490EX (ICX814 CCD)","icx814","ccd",false],
    ["Atik","Atik 16200 (KAF-16200 CCD)","kaf16200","ccd",false],

    ["Starlight Xpress","Starlight Xpress Trius PRO-694 (ICX694 CCD)","icx694","ccd",false],
    ["Starlight Xpress","Starlight Xpress Trius PRO-814 (ICX814 CCD)","icx814","ccd",false],

    ["Meade","Meade DSI IV Color/Mono (MN34230)","mn34230","cmos",false],

    ["Moravian","Moravian C1×26000 / C3-26000 (IMX571)","imx571","cmos",true],
    ["Moravian","Moravian C1×61000 / C3-61000 (IMX455)","imx455","cmos",true],
    ["Moravian","Moravian C1+9000 (IMX533)","imx533","cmos",true],
    ["Moravian","Moravian C1+46000 (IMX492)","imx492","cmos",true],
    ["Moravian","Moravian C4-16000 (GSENSE4040)","gsense4040","cmos",true],
    ["Moravian","Moravian C5A/C5S-100M (IMX461)","imx461","cmos",true],
    ["Moravian","Moravian C5A/C5S-150M (IMX411)","imx411","cmos",true],
    ["Moravian","Moravian G2-8300 (KAF-8300 CCD)","kaf8300","ccd",true],
    ["Moravian","Moravian G3-6300 (KAF-6303 CCD)","kaf6303","ccd",true],
    ["Moravian","Moravian G3-11000 (KAI-11002 CCD)","kai11002","ccd",true],
    ["Moravian","Moravian G3-16200 (KAF-16200 CCD)","kaf16200","ccd",true],
    ["Moravian","Moravian G4-9000 (KAF-9000 CCD)","kaf9000","ccd",true],
    ["Moravian","Moravian G4-16000 (KAF-16803 CCD)","kaf16803","ccd",true],

    ["SBIG / Diffraction Limited","SBIG Aluma AC2020BSI (GSENSE2020BSI)","gsense2020bsi","cmos",true],
    ["SBIG / Diffraction Limited","SBIG Aluma AC4040 (GSENSE4040)","gsense4040","cmos",true],
    ["SBIG / Diffraction Limited","SBIG Aluma AC4040BSI (GSENSE4040BSI)","gsense4040bsi","cmos",true],
    ["SBIG / Diffraction Limited","SBIG STC-7 (IMX428)","imx428","cmos",true],
    ["SBIG / Diffraction Limited","SBIG Aluma CCD694 (ICX694 CCD)","icx694","ccd",true],
    ["SBIG / Diffraction Limited","SBIG Aluma CCD814 (ICX814 CCD)","icx814","ccd",true],
    ["SBIG / Diffraction Limited","SBIG Aluma CCD8300 (KAF-8300 CCD)","kaf8300","ccd",true],
    ["SBIG / Diffraction Limited","SBIG STF-8300 M/C (KAF-8300 CCD)","kaf8300","ccd",true],
    ["SBIG / Diffraction Limited","SBIG STT-8300M (KAF-8300 CCD)","kaf8300","ccd",true],
    ["SBIG / Diffraction Limited","SBIG STXL-6303E (KAF-6303 CCD)","kaf6303","ccd",true],
    ["SBIG / Diffraction Limited","SBIG STXL-11002 (KAI-11002 CCD)","kai11002","ccd",true],
    ["SBIG / Diffraction Limited","SBIG STXL-16200 (KAF-16200 CCD)","kaf16200","ccd",true],

    ["Canon (DSLR/mirrorless)","Canon EOS Ra",null,"dslr",true,14],
    ["Canon (DSLR/mirrorless)","Canon EOS R",null,"dslr",true,14],
    ["Canon (DSLR/mirrorless)","Canon EOS R5",null,"dslr",true,14],
    ["Canon (DSLR/mirrorless)","Canon EOS R6",null,"dslr",true,14],
    ["Canon (DSLR/mirrorless)","Canon EOS 60Da",null,"dslr",true,14],
    ["Canon (DSLR/mirrorless)","Canon EOS 6D",null,"dslr",true,14],
    ["Canon (DSLR/mirrorless)","Canon EOS 6D Mark II",null,"dslr",true,14],

    ["Nikon (DSLR/mirrorless)","Nikon D810a",null,"dslr",true,14],
    ["Nikon (DSLR/mirrorless)","Nikon D750",null,"dslr",true,14],
    ["Nikon (DSLR/mirrorless)","Nikon D5600",null,"dslr",true,14],

    ["Sony (mirrorless)","Sony A7 III",null,"dslr",true,14],
    ["Sony (mirrorless)","Sony A7 IV",null,"dslr",true,14],
    ["Sony (mirrorless)","Sony A7R III",null,"dslr",true,14],
    ["Sony (mirrorless)","Sony A7R IV",null,"dslr",true,14],
    ["Sony (mirrorless)","Sony A7R V",null,"dslr",true,14],
    ["Sony (mirrorless)","Sony A7S / II / III",null,"dslr",true,14],

    ["Fujifilm (mirrorless)","Fujifilm X-T3",null,"dslr",true,14],
    ["Fujifilm (mirrorless)","Fujifilm X-T4",null,"dslr",true,14],
    ["Fujifilm (mirrorless)","Fujifilm X-T5",null,"dslr",true,14]
  ];
  var selectedAmp=false;

  (function buildCamList(){
    var sel=document.getElementById('camModel');
    var o=document.createElement('option'); o.value="custom"; o.textContent="Custom / not listed"; sel.appendChild(o);
    var order=[], byGroup={};
    CAMERAS.forEach(function(c,i){ var g=c[0]; if(!byGroup[g]){byGroup[g]=[]; order.push(g);} byGroup[g].push(i); });
    order.forEach(function(g){
      var og=document.createElement('optgroup'); og.label=g;
      byGroup[g].forEach(function(i){ var op=document.createElement('option'); op.value="c"+i; op.textContent=CAMERAS[i][1]; og.appendChild(op); });
      sel.appendChild(og);
    });
    sel.value="custom";
  })();

  function camSpec(v){
    if(v==="custom" || v.charAt(0)!=="c") return null;
    var c=CAMERAS[parseInt(v.slice(1),10)]; if(!c) return null;
    var bits=c[5] || (c[2]?SENSORS[c[2]].bits:14);
    var amp=c[2]?SENSORS[c[2]].amp:false;
    return {bits:bits, type:c[3], shutter:c[4], amp:amp};
  }

  document.getElementById('camModel').addEventListener('change', function(){
    var s=camSpec(this.value);
    if(!s){ selectedAmp=false; return; }
    document.getElementById('bits').value=String(s.bits);
    document.getElementById('camType').value=s.type;
    document.getElementById('shutter').checked=s.shutter;
    selectedAmp=s.amp;
  });

  // ---------- Filter model ----------
  var FILTERS = {
    L:{label:'Luminance / Clear', nb:false, f:1.0},
    R:{label:'Red', nb:false, f:1.4},
    G:{label:'Green', nb:false, f:1.3},
    B:{label:'Blue', nb:false, f:1.9},
    OSC:{label:'OSC / UV-IR cut', nb:false, f:1.2},
    Ha:{label:'Hα', nb:true, f:{wide:14, mid:20, narrow:28}},
    OIII:{label:'OIII', nb:true, f:{wide:18, mid:26, narrow:36}},
    SII:{label:'SII', nb:true, f:{wide:24, mid:35, narrow:48}},
    DUAL:{label:'Dual-band', nb:true, f:{wide:6, mid:7, narrow:9}}
  };
  var FILTER_ORDER = ['L','R','G','B','OSC','Ha','OIII','SII','DUAL'];
  function nbWidth(){ return document.getElementById('nbWidth').value; }
  function factor(id){ var e=FILTERS[id]; if(!e) return 1; return (typeof e.f==='object')?e.f[nbWidth()]:e.f; }
  function selectedFilters(){
    var out=[]; document.querySelectorAll('#filterChips input:checked').forEach(function(c){out.push(c.value)});
    return FILTER_ORDER.filter(function(id){return out.indexOf(id)>=0});
  }

  // ---------- Mode ----------
  var advMode=false;
  var mb=document.getElementById('modeBasic'), ma=document.getElementById('modeAdv');
  function setMode(adv){ advMode=adv; mb.classList.toggle('ffc-on',!adv); ma.classList.toggle('ffc-on',adv);
    document.getElementById('advBlock').style.display=adv?'block':'none'; }
  mb.addEventListener('click',function(){setMode(false)});
  ma.addEventListener('click',function(){setMode(true)});

  function syncRefFilter(){
    var sel=document.getElementById('refFilter'); var cur=sel.value;
    var fs=selectedFilters(); if(fs.length===0) fs=['L'];
    sel.innerHTML='';
    fs.forEach(function(id){ var o=document.createElement('option'); o.value=id; o.textContent=FILTERS[id].label; sel.appendChild(o); });
    if(fs.indexOf(cur)>=0) sel.value=cur;
  }
  document.getElementById('filterChips').addEventListener('change',syncRefFilter);
  document.getElementById('nbWidth').addEventListener('change',syncRefFilter);
  syncRefFilter();

  function syncBrightUnit(){
    var u=document.getElementById('brightUnit').value==='pct'?'(%)':'(steps)';
    document.getElementById('refBrightUnitLbl').textContent=u;
    document.getElementById('newBrightUnitLbl').textContent=u;
  }
  document.getElementById('brightUnit').addEventListener('change',syncBrightUnit);
  syncBrightUnit();

  // ---------- Helpers ----------
  function num(id,dflt){ var v=parseFloat(document.getElementById(id).value); return isNaN(v)?dflt:v; }
  function val(id){ return document.getElementById(id).value; }
  function fmtExp(s){
    if(s>=100) return s.toFixed(0)+' s';
    if(s>=10) return s.toFixed(1)+' s';
    if(s>=0.1) return s.toFixed(2)+' s';
    return (s*1000).toFixed(0)+' ms';
  }
  function commas(n){ return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','); }
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;');}

  // ---------- Core compute ----------
  function compute(){
    var bits=parseInt(val('bits'),10);
    var maxADU=Math.pow(2,bits)-1;
    var pct=Math.min(75,Math.max(10,num('targetPct',40)));
    var offset=num('offset',0); if(isNaN(offset)||offset<0) offset=0;
    var aduTarget=Math.round(offset+(maxADU-offset)*pct/100);

    var camType=val('camType');
    var source=val('source');
    var shutter=document.getElementById('shutter').checked;
    var fratio=num('fratio',5.5);
    var minExp=num('minExp',0.5), maxExp=num('maxExp',12);

    var floors=[];
    if(source==='pwm'){ floors.push(1.0); }
    else if(source==='el'){ floors.push(0.02); }
    else if(source==='sky'){ floors.push(0.5); }
    else { floors.push(0.02); }
    if(shutter){ floors.push(2.0); }
    var floor=Math.max.apply(null,floors);

    var fs=selectedFilters(); if(fs.length===0){ fs=['L']; }

    var perFilter=[], refInfo=null;
    if(advMode){
      var refId=val('refFilter'); if(fs.indexOf(refId)<0){ refId=fs[0]; }
      var refExp=num('refExp',0.4);
      var refBright=num('refBright',30), newBright=num('newBright',refBright);
      if(refBright<=0) refBright=1; if(newBright<=0) newBright=refBright;
      var refADUin=num('refADU',NaN);
      var refADU=(!isNaN(refADUin)&&refADUin>0)?refADUin:aduTarget;
      var refFac=factor(refId);
      refInfo={id:refId,exp:refExp,bright:refBright,newBright:newBright,adu:refADU};
      fs.forEach(function(id){
        var e=refExp*(factor(id)/refFac)*(refBright/newBright)*(aduTarget/refADU);
        perFilter.push({id:id,label:FILTERS[id].label,exp:e,nb:FILTERS[id].nb});
      });
    } else {
      // Camera-class sensitivity: modern cooled CMOS is the reference. CCDs generally
      // have lower QE and are run at longer exposures, so their flats are longer too;
      // DSLR/mirrorless sit in between. (Rough — Advanced mode removes the guesswork.)
      var SENS={cmos:1.0, dslr:1.3, ccd:2.5};
      var baseL=2.0*Math.pow(fratio/5,2)*(pct/40)*(SENS[camType]||1.0);
      // Bright EL/LED panels are run dim for broadband and turned up (often to max)
      // for narrowband, so narrowband lands FAR shorter than a fixed-brightness
      // estimate implies. NB_HEADROOM models that per-band brightness boost.
      var NB_HEADROOM=5;
      fs.forEach(function(id){
        var e=baseL*factor(id);
        if(FILTERS[id].nb){ e=e/NB_HEADROOM; }
        perFilter.push({id:id,label:FILTERS[id].label,exp:e,nb:FILTERS[id].nb});
      });
    }

    perFilter.forEach(function(p){
      p.flags=[];
      if(p.exp<floor){ p.flags.push({t:'warn', m:'below flicker/shutter floor'}); }
      if(p.exp<minExp){ p.flags.push({t:'warn', m:'below your min'}); }
      // Basic mode is a rough estimate that can't know your panel's brightness, so
      // "over max" is only a soft note there; Advanced mode (anchored to a real flat) treats it as firm.
      if(p.exp>maxExp){ p.flags.push({t: advMode?'bad':'warn', m: advMode?'exceeds your max':'turn panel up / raise max'}); }
      if(p.flags.length===0){ p.flags.push({t:'ok', m:'in range'}); }
    });

    var exps=perFilter.map(function(p){return p.exp;});
    var maxFilterExp=Math.max.apply(null,exps);
    var hasNB=perFilter.some(function(p){return p.nb;});
    var recLo=Math.max(floor,minExp), recHi=maxExp;

    // Panel starting brightness
    var brightMax=num('brightMax',255), brightUnit=val('brightUnit');
    var startBrightPct, startBrightMsg;
    if(advMode){
      startBrightPct=brightUnit==='pct'?refInfo.newBright:(refInfo.newBright/brightMax*100);
      startBrightMsg='Using your session brightness';
    } else {
      var desiredShort=Math.max(floor*2,2);
      var shortExpAt50=Math.min.apply(null,exps);
      var b=50*(shortExpAt50/desiredShort);
      startBrightPct=Math.min(100,Math.max(5,b));
      startBrightMsg='Start here, then fine-tune to the ADU target';
    }
    var startBrightStr = brightUnit==='pct'
      ? Math.round(startBrightPct)+'%'
      : Math.round(startBrightPct/100*brightMax)+' / '+brightMax+' ('+Math.round(startBrightPct)+'%)';

    // Flat count
    var count, override=num('flatOverride',NaN);
    if(!isNaN(override)&&override>0){ count=Math.round(override); }
    else { count=25; if(fratio<=4.5) count=40; if(hasNB) count=Math.max(count,40); if(fratio<=3.2) count=50; }
    var noiseFactor=1/Math.sqrt(count);

    var eADU=num('eADU',NaN), readN=num('readN',NaN), snrText=null;
    if(!isNaN(eADU)&&eADU>0){
      var signalE=(aduTarget-offset)*eADU, rn=(!isNaN(readN)&&readN>=0)?readN:0;
      var singleNoiseE=Math.sqrt(signalE+rn*rn), combNoiseE=singleNoiseE/Math.sqrt(count);
      snrText='Per-frame SNR ≈ '+(signalE/singleNoiseE).toFixed(0)+'; master-flat SNR ≈ '+(signalE/combNoiseE).toFixed(0)+
              ' ('+commas(signalE)+' e− signal, '+combNoiseE.toFixed(1)+' e− noise).';
    }
    var noiseText='Stacking '+count+' flats cuts the flat’s random noise to '+(noiseFactor*100).toFixed(0)+
                  '% of a single frame (÷'+(1/noiseFactor).toFixed(1)+').';

    // Dark flats vs bias
    var calRec, calWhy;
    if(camType==='cmos'){
      if(maxFilterExp>30 || hasNB || selectedAmp){
        calRec='Dark flats';
        calWhy=(selectedAmp?'Your sensor tends to show amp glow, and ':'')+'long/narrowband flats ('+fmtExp(maxFilterExp)+' max) accumulate dark current — a matched dark flat is the safe, always-correct choice.';
      } else {
        calRec='Dark flats (bias OK if your sensor is well-behaved)';
        calWhy='Most CMOS sensors have unstable bias at ultra-short exposures, so matched dark flats are the reliable default. Stable IMX571-class sensors (ASI2600/QHY268) also calibrate fine with bias.';
      }
    } else if(camType==='ccd'){
      if(maxFilterExp>30){ calRec='Dark flats'; calWhy='Flats over ~30 s (Adam Block’s rule) accumulate enough dark signal that a matched dark flat calibrates better than bias.'; }
      else { calRec='Bias frames'; calWhy='CCDs are linear and stable at short exposures, so bias frames are adequate for flats under ~30 s. Use dark flats for longer narrowband flats.'; }
    } else {
      calRec='Dark flats'; calWhy='Uncooled DSLR/mirrorless sensors vary with temperature; matched dark flats capture the actual pedestal. Very short flats can use bias if your camera’s bias is stable.';
    }

    return {aduTarget:aduTarget,maxADU:maxADU,pct:pct,offset:offset,bits:bits,floor:floor,source:source,shutter:shutter,
      perFilter:perFilter,maxFilterExp:maxFilterExp,hasNB:hasNB,recLo:recLo,recHi:recHi,minExp:minExp,maxExp:maxExp,
      startBrightStr:startBrightStr,startBrightMsg:startBrightMsg,count:count,noiseFactor:noiseFactor,noiseText:noiseText,
      snrText:snrText,calRec:calRec,calWhy:calWhy,advMode:advMode,refInfo:refInfo};
  }

  // ---------- Render ----------
  function kpiBox(l,v,d){ return '<div class="ffc-kpi"><div class="ffc-l">'+l+'</div><div class="ffc-v">'+v+'</div><div class="ffc-d">'+d+'</div></div>'; }
  function alert(cls,ic,title,body){ return '<div class="ffc-alert '+cls+'"><div class="ffc-ic">'+ic+'</div><div><b>'+title+'</b><br>'+body+'</div></div>'; }

  function render(R){
    var kpi='';
    kpi+=kpiBox('Target ADU', commas(R.aduTarget), R.pct+'% of '+commas(R.maxADU)+' ('+R.bits+'-bit)');
    kpi+=kpiBox('Working exposure', fmtExp(R.recLo)+'&ndash;'+fmtExp(R.recHi), 'stay above '+fmtExp(R.floor)+' floor');
    kpi+=kpiBox('Panel start brightness', R.startBrightStr, R.startBrightMsg);
    kpi+=kpiBox('Flats per filter', R.count, '÷'+(1/R.noiseFactor).toFixed(1)+' noise reduction');
    document.getElementById('kpis').innerHTML=kpi;

    document.getElementById('modeLabel').textContent = R.advMode
      ? 'Predicted from your measured flat ('+FILTERS[R.refInfo.id].label+', '+fmtExp(R.refInfo.exp)+').'
      : 'Ballpark estimates from your setup — switch to Advanced mode and enter one measured flat for precise per-filter exposures.';

    var rows='<thead><tr><th>Filter</th><th>Type</th><th>Suggested exposure</th><th>Status</th></tr></thead><tbody>';
    R.perFilter.forEach(function(p){
      var f=p.flags[0], cls=f.t==='ok'?'ffc-ok':(f.t==='bad'?'ffc-bad':'ffc-warn');
      var icon=f.t==='ok'?'✓':(f.t==='bad'?'✕':'⚠');
      var flagsTxt=p.flags.map(function(x){return x.m;}).join(', ');
      rows+='<tr><td>'+esc(p.label)+'</td><td><span class="ffc-pill '+(p.nb?'ffc-nb':'ffc-bb')+'">'+(p.nb?'Narrowband':'Broadband')+'</span></td>'+
        '<td class="ffc-exp-v">'+fmtExp(p.exp)+'</td><td><span class="ffc-flag '+cls+'">'+icon+' '+esc(flagsTxt)+'</span></td></tr>';
    });
    rows+='</tbody>';
    document.getElementById('expTable').innerHTML=rows;
    document.getElementById('expHint').textContent = R.advMode
      ? 'Scaled from your measured flat using mean ADU ≈ k × exposure × brightness.'
      : 'Rough ballpark only — broadband dimmed, narrowband with the panel turned up. Absolute times depend heavily on your panel’s brightness (bright EL/LED panels run much shorter); use Advanced mode with one measured flat for real numbers.';

    var note=[];
    if(R.hasNB){ note.push('Narrowband needs a brighter panel (often max) or a longer exposure than broadband — that’s normal, and bright EL/LED panels keep it short. Measure one flat in Advanced mode for exact per-filter times.'); }
    note.push('Always confirm the mean/histogram on your own frames; these are starting values.');
    document.getElementById('expNote').innerHTML=note.join(' ');

    var A=[];
    if(R.source==='pwm'){
      var tooShort=R.perFilter.some(function(p){return p.exp<1.0;})||R.recLo<1.0;
      A.push(tooShort
        ? alert('ffc-warn','⚠','LED flicker risk','Your LED panel dims by PWM. Exposures under ~1 s can show shifting horizontal banding. <b>Dim the panel and lengthen the exposure</b> rather than going shorter, or switch to an EL/constant-current panel.')
        : alert('ffc-ok','✓','Flicker under control','Your exposures stay above the ~1 s PWM floor — banding is unlikely. Still, shoot enough frames so any residual averages out.'));
    } else if(R.source==='el'||R.source==='tshirt'){
      A.push(alert('ffc-ok','✓','Flicker-free source','No PWM flicker from this source — you can use short exposures freely (mind the shutter floor if applicable).'));
    } else if(R.source==='sky'){
      A.push(alert('ffc-info','ℹ','Sky flats change fast','Twilight brightness shifts quickly — let your software auto-adjust exposure each frame, and work in a fixed patch of sky near zenith.'));
    }
    if(R.shutter){
      var shShort=R.perFilter.some(function(p){return p.exp<2.0;})||R.recLo<2.0;
      A.push(shShort
        ? alert('ffc-warn','⚠','Shutter-shadow risk','Your camera has a mechanical shutter. Very short flats can imprint a moving shutter shadow across the frame. Keep flats <b>at or above ~1–2 s</b> — dim the panel to lengthen them.')
        : alert('ffc-ok','✓','Shutter shadow avoided','Exposures are long enough that the mechanical shutter opens fully and evenly across the frame.'));
    }
    var over=R.perFilter.filter(function(p){return p.exp>R.maxExp;});
    if(over.length){
      var overList=over.map(function(p){return esc(p.label)+' ('+fmtExp(p.exp)+')';}).join(', ');
      A.push(R.advMode
        ? alert('ffc-bad','✕','Exposure exceeds your max','These filters need more than your '+fmtExp(R.maxExp)+' max: <b>'+overList+'</b>. Raise the max exposure, or increase panel brightness to shorten them.')
        : alert('ffc-warn','⚠','Some filters look long (estimate)','At a typical brightness these come out over your '+fmtExp(R.maxExp)+' max: <b>'+overList+'</b>. Absolute times depend heavily on panel brightness — bright EL/LED panels run much shorter, especially with the panel turned up for narrowband. Turn the panel up, raise the max, or use Advanced mode with one measured flat for exact times.'));
    }
    if(R.pct>65){ A.push(alert('ffc-warn','⚠','Target ADU is high','Targeting '+R.pct+'% risks clipping the brightest pixels and pushing the sensor out of its linear range. 40–50% is the safe sweet spot.')); }
    document.getElementById('alerts').innerHTML=A.join('');

    var rec='';
    rec+='<div class="ffc-box"><h4>Flat frames per filter</h4><span class="ffc-big">'+R.count+' frames</span><p>'+R.noiseText+' 20–30 suits most rigs; 40–50 for fast optics or narrowband.</p></div>';
    var noiseInner=R.snrText?R.snrText:'Enter your sensor’s gain (e−/ADU) in the optional section for a concrete SNR figure. Otherwise: a well-exposed flat is shot-noise limited, and stacking '+R.count+' cuts that noise to '+(R.noiseFactor*100).toFixed(0)+'%.';
    rec+='<div class="ffc-box"><h4>Approx. combined-flat noise</h4><span class="ffc-big">÷'+(1/R.noiseFactor).toFixed(1)+' vs one frame</span><p>'+noiseInner+'</p></div>';
    rec+='<div class="ffc-box"><h4>Calibrate flats with</h4><span class="ffc-big">'+esc(R.calRec)+'</span><p>'+R.calWhy+'</p></div>';
    rec+='<div class="ffc-box"><h4>Match &amp; re-shoot</h4><span class="ffc-big">Lock the train</span><p>Keep gain, offset, temperature, binning, focus &amp; rotation identical to your lights. Re-shoot flats after any refocus, rotation or new dust.</p></div>';
    document.getElementById('reco').innerHTML=rec;

    document.getElementById('results').style.display='block';
    document.getElementById('results').scrollIntoView({behavior:'smooth',block:'start'});
  }

  document.getElementById('calcBtn').addEventListener('click',function(){ render(compute()); });
  document.getElementById('resetBtn').addEventListener('click',function(){
    var d={aperture:80,fratio:5.5,gain:100,minExp:0.5,maxExp:12,targetPct:40,brightMax:255,refBright:30,refExp:0.4,newBright:30};
    for(var k in d){ document.getElementById(k).value=d[k]; }
    ['offset','refADU','eADU','readN','flatOverride'].forEach(function(id){document.getElementById(id).value='';});
    document.getElementById('bits').value='12';
    document.getElementById('camType').value='cmos';
    document.getElementById('camModel').value='custom';
    document.getElementById('source').value='pwm';
    document.getElementById('brightUnit').value='steps';
    document.getElementById('nbWidth').value='wide';
    document.getElementById('shutter').checked=false;
    selectedAmp=false;
    document.querySelectorAll('#filterChips input').forEach(function(c){ c.checked=['L','R','G','B'].indexOf(c.value)>=0; });
    syncRefFilter(); syncBrightUnit();
    document.getElementById('results').style.display='none';
    window.scrollTo({top:0,behavior:'smooth'});
  });

})();
